import {
  SEARCH_DOCUMENT_TYPE,
  SEARCH_DOCUMENT_TYPE_SUCCESS,
  SEARCH_DOCUMENT_TYPE_ERROR,
  SEARCH_EQUIPMENT_DELIVERY_ORDER,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS,
  SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR,
  SEARCH_DELIVERY_ORDER_LINE_LOT,
  SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS,
  SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR,
  SEARCH_DELIVERY_ORDER_LINE,
  SEARCH_DELIVERY_ORDER_LINE_SUCCESS,
  SEARCH_DELIVERY_ORDER_LINE_ERROR,
  SEARCH_STATUS_REVIEW,
  SEARCH_STATUS_REVIEW_SUCCESS,
  SEARCH_STATUS_REVIEW_ERROR,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS,
  SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR,
  SEARCH_CATEGORY_MAINTENANCE_DELAY,
  SEARCH_CATEGORY_MAINTENANCE_DELAY_SUCCESS,
  SEARCH_CATEGORY_MAINTENANCE_DELAY_ERROR,
  SEARCH_HOSPITAL_SECTION,
  SEARCH_HOSPITAL_SECTION_SUCCESS,
  SEARCH_HOSPITAL_SECTION_ERROR,
  SEARCH_HOSPITAL_SERVICE,
  SEARCH_HOSPITAL_SERVICE_SUCCESS,
  SEARCH_HOSPITAL_SERVICE_ERROR,
  SEARCH_REQUEST_TYPE,
  SEARCH_REQUEST_TYPE_SUCCESS,
  SEARCH_REQUEST_TYPE_ERROR,
  SEARCH_REQUEST_TYPE_DETAIL,
  SEARCH_REQUEST_TYPE_DETAIL_SUCCESS,
  SEARCH_REQUEST_TYPE_DETAIL_ERROR,
  SEARCH_PRIORITY,
  SEARCH_PRIORITY_SUCCESS,
  SEARCH_PRIORITY_ERROR,
  SEARCH_REQUEST_STATUS,
  SEARCH_REQUEST_STATUS_SUCCESS,
  SEARCH_REQUEST_STATUS_ERROR,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  SEARCH_ACTION_REQUEST,
  SEARCH_ACTION_REQUEST_SUCCESS,
  SEARCH_ACTION_REQUEST_ERROR,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  SEARCH_BMP_AGENCY,
  SEARCH_BMP_AGENCY_SUCCESS,
  SEARCH_BMP_AGENCY_ERROR,
  SEARCH_RISK_TYPE,
  SEARCH_RISK_TYPE_SUCCESS,
  SEARCH_RISK_TYPE_ERROR,
  SEARCH_GHTF,
  SEARCH_GHTF_SUCCESS,
  SEARCH_GHTF_ERROR,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  SEARCH_DIAGNOSTIC_CLASS_ERROR,
  SEARCH_ISO,
  SEARCH_ISO_SUCCESS,
  SEARCH_ISO_ERROR,
  SEARCH_GT_CERTIFICATE,
  SEARCH_GT_CERTIFICATE_SUCCESS,
  SEARCH_GT_CERTIFICATE_ERROR,
  SEARCH_SERVICE_TYPE,
  SEARCH_SERVICE_TYPE_SUCCESS,
  SEARCH_SERVICE_TYPE_ERROR,
  SEARCH_BIOEQUIVALENCE,
  SEARCH_BIOEQUIVALENCE_SUCCESS,
  SEARCH_BIOEQUIVALENCE_ERROR,
  SEARCH_VEHICLE_TYPE,
  SEARCH_VEHICLE_TYPE_SUCCESS,
  SEARCH_VEHICLE_TYPE_ERROR,
  SEARCH_FREQUENCY_MTO,
  SEARCH_FREQUENCY_MTO_SUCCESS,
  SEARCH_FREQUENCY_MTO_ERROR,
  SEARCH_AMBULANCE_PLATE,
  SEARCH_AMBULANCE_PLATE_SUCCESS,
  SEARCH_AMBULANCE_PLATE_ERROR,
  SEARCH_AMBULANCE_CHASIS,
  SEARCH_AMBULANCE_CHASIS_SUCCESS,
  SEARCH_AMBULANCE_CHASIS_ERROR,
  SEARCH_AMBULANCE_CODE_IGSS,
  SEARCH_AMBULANCE_CODE_IGSS_SUCCESS,
  SEARCH_AMBULANCE_CODE_IGSS_ERROR
} from '../actions';
 
const INIT_STATE = {
  modal: false,
  init:true,
  document_type: {
    data: [],
    loading: true,
    message: ''
  },
  equipment_delivery_order: {
    data: [],
    loading: true,
    message: ''
  },
  delivery_order_line_lot: {
    data: [],
    loading: true,
    message: ''
  },
  status_review: {
    data: [],
    loading: true,
    message: ''
  },
  equipment_schedule_maintenance_detail: {
    data: [],
    loading: true,
    message: ''
  },
  hospital_section: {
    data: [],
    loading: true,
    message: ''
  },
  category_maintenance_delay: {
    data: [],
    loading: true,
    message: ''
  },
  hospital_service: {
    data: [],
    loading: true,
    message: ''
  },
  request_type: {
    data: [],
    loading: true,
    message: ''
  },
  request_type_detail: {
    data: [],
    loading: true,
    message: ''
  },
  priority: {
    data: [],
    loading: true,
    message: ''
  },
  request_status: {
    data: [],
    loading: true,
    message: ''
  },
  request_process_type: {
    data: [],
    loading: true,
    message: ''
  },
  action_request: {
    data: [],
    loading: true,
    message: ''
  },
  health_registry_agency: {
    data: [],
    loading: true,
    message: ''
  },
  bmc_agency: {
    data: [],
    loading: true,
    message: ''
  },
  risk_type: {
    data: [],
    loading: true,
    message: ''
  },
  ghtf: {
    data: [],
    loading: true,
    message: ''
  },
  diagnostic_class: {
    data: [],
    loading: true,
    message: ''
  },
  iso: {
    data: [],
    loading: true,
    message: ''
  },
  gt_certificate: {
    data: [],
    loading: true,
    message: ''
  },
  service_type: {
    data: [],
    loading: true,
    message: ''
  },
  bioequivalence: {
    data: [],
    loading: true,
    message: ''
  },
  vehicle_type: {
    data: [],
    loading: true,
    message: ''
  },
  frequency_mto: {
    data: [],
    loading: true,
    message: ''
  },
  ambulance_plate: {
    data: [],
    loading: true,
    message: ''
  },
  ambulance_chasis: {
    data: [],
    loading: true,
    message: ''
  },
  ambulance_code_igss: {
    data: [],
    loading: true,
    message: ''
  },
  value:{
    request_type: false,
    document_type: false,
    equipment_delivery_order: false,
    delivery_order_line_lot: false,
    status_review: false,
    equipment_schedule_maintenance_detail: false, 
    hospital_section: false,
    category_maintenance_delay: false,
    hospital_service: false,
    request_type_detail: false,
    priority: false,
    request_status: false,
    request_process_type: false,
    risk_type: false,
    ghtf: false,
    diagnostic_class: false,
    iso: false,
    service_type: false,
    priority:'Si',
    code: '',
    action_request: '',
    health_registry_agency: '',
    bmc_agency: '',
    gt_certificate: false,
    bioequivalence: false,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SEARCH_DOCUMENT_TYPE:
      return {
        ...state,
        init:false,
        document_type:{
          ...state.document_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        document_type:{
          ...state.document_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_DOCUMENT_TYPE_ERROR:
      return {
        ...state,
        document_type:{
          ...state.document_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_EQUIPMENT_DELIVERY_ORDER:
      return {
        ...state,
        init:false,
        equipment_delivery_order:{
          ...state.equipment_delivery_order,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_EQUIPMENT_DELIVERY_ORDER_SUCCESS:
      return {
        ...state,
        equipment_delivery_order:{
          ...state.equipment_delivery_order,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_EQUIPMENT_DELIVERY_ORDER_ERROR:
      return {
        ...state,
        equipment_delivery_order:{
          ...state.equipment_delivery_order,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_LOT:
      return {
        ...state,
        init:false,
        delivery_order_line_lot:{
          ...state.delivery_order_line_lot,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_LOT_SUCCESS:
      return {
        ...state,
        delivery_order_line_lot:{
          ...state.delivery_order_line_lot,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_LOT_ERROR:
      return {
        ...state,
        delivery_order_line_lot:{
          ...state.delivery_order_line_lot,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE:
      return {
        ...state,
        init:false,
        delivery_order_line:{
          ...state.delivery_order_line,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_SUCCESS:
      return {
        ...state,
        delivery_order_line:{
          ...state.delivery_order_line,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_DELIVERY_ORDER_LINE_ERROR:
      return {
        ...state,
        delivery_order_line:{
          ...state.delivery_order_line,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_STATUS_REVIEW:
      return {
        ...state,
        init:false,
        status_review:{
          ...state.status_review,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_STATUS_REVIEW_SUCCESS:
      return {
        ...state,
        status_review:{
          ...state.status_review,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_STATUS_REVIEW_ERROR:
      return {
        ...state,
        status_review:{
          ...state.status_review,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL:
      return {
        ...state,
        init:false,
        equipment_schedule_maintenance_detail:{
          ...state.equipment_schedule_maintenance_detail,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_SUCCESS:
      return {
        ...state,
        equipment_schedule_maintenance_detail:{
          ...state.equipment_schedule_maintenance_detail,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_EQUIPMENT_SCHEDULE_MAINTENANCE_DETAIL_ERROR:
      return {
        ...state,
        equipment_schedule_maintenance_detail:{
          ...state.equipment_schedule_maintenance_detail,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_CATEGORY_MAINTENANCE_DELAY:
      return {
        ...state,
        init:false,
        category_maintenance_delay:{
          ...state.category_maintenance_delay,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_CATEGORY_MAINTENANCE_DELAY_SUCCESS:
      return {
        ...state,
        category_maintenance_delay:{
          ...state.category_maintenance_delay,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_CATEGORY_MAINTENANCE_DELAY_ERROR:
      return {
        ...state,
        category_maintenance_delay:{
          ...state.category_maintenance_delay,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_HOSPITAL_SECTION:
      return {
        ...state,
        init:false,
        hospital_section:{
          ...state.hospital_section,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SECTION_SUCCESS:
      return {
        ...state,
        hospital_section:{
          ...state.hospital_section,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SECTION_ERROR:
      return {
        ...state,
        hospital_section:{
          ...state.hospital_section,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_HOSPITAL_SERVICE:
      return {
        ...state,
        init:false,
        hospital_service:{
          ...state.hospital_service,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SERVICE_SUCCESS:
      return {
        ...state,
        hospital_service:{
          ...state.hospital_service,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_HOSPITAL_SERVICE_ERROR:
      return {
        ...state,
        hospital_service:{
          ...state.hospital_service,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_TYPE:
      return {
        ...state,
        init:false,
        request_type:{
          ...state.request_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_SUCCESS:
      return {
        ...state,
        request_type:{
          ...state.request_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_ERROR:
      return {
        ...state,
        request_type:{
          ...state.request_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_TYPE_DETAIL:
      return {
        ...state,
        init:false,
        request_type_detail:{
          ...state.request_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_DETAIL_SUCCESS:
      return {
        ...state,
        request_type_detail:{
          ...state.request_type_detail,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_TYPE_DETAIL_ERROR:
      return {
        ...state,
        request_type_detail:{
          ...state.request_type_detail,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_PRIORITY:
      return {
        ...state,
        init:false,
        priority:{
          ...state.priority,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_PRIORITY_SUCCESS:
      return {
        ...state,
        priority:{
          ...state.priority,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_PRIORITY_ERROR:
      return {
        ...state,
        priority:{
          ...state.priority,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_STATUS:
      return {
        ...state,
        init:false,
        request_status:{
          ...state.request_status,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_STATUS_SUCCESS:
      return {
        ...state,
        request_status:{
          ...state.request_status,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_STATUS_ERROR:
      return {
        ...state,
        request_status:{
          ...state.request_status,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_REQUEST_PROCESS_TYPE:
      return {
        ...state,
        init:false,
        request_process_type:{
          ...state.request_process_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_REQUEST_PROCESS_TYPE_SUCCESS:
      return {
        ...state,
        request_process_type:{
          ...state.request_process_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_REQUEST_PROCESS_TYPE_ERROR:
      return {
        ...state,
        request_process_type:{
          ...state.request_process_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_ACTION_REQUEST:
      return {
        ...state,
        init:false,
        action_request:{
          ...state.action_request,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_ACTION_REQUEST_SUCCESS:
      return {
        ...state,
        action_request:{
          ...state.action_request,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_ACTION_REQUEST_ERROR:
      return {
        ...state,
        action_request:{
          ...state.action_request,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_HEALTH_REGISTRY_AGENCY:
      return {
        ...state,
        init:false,
        health_registry_agency:{
          ...state.health_registry_agency,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS:
      return {
        ...state,
        health_registry_agency:{
          ...state.health_registry_agency,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_HEALTH_REGISTRY_AGENCY_ERROR:
      return {
        ...state,
        health_registry_agency:{
          ...state.health_registry_agency,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }

    case SEARCH_BMP_AGENCY:
      return {
        ...state,
        init:false,
        bmp_agency:{
          ...state.bmp_agency,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_BMP_AGENCY_SUCCESS:
      return {
        ...state,
        bmp_agency:{
          ...state.bmp_agency,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_BMP_AGENCY_ERROR:
      return {
        ...state,
        bmp_agency:{
          ...state.bmp_agency,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_RISK_TYPE:
      return {
        ...state,
        init:false,
        risk_type:{
          ...state.risk_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_RISK_TYPE_SUCCESS:
      return {
        ...state,
        risk_type:{
          ...state.risk_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_RISK_TYPE_ERROR:
      return {
        ...state,
        risk_type:{
          ...state.risk_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_GHTF:
      return {
        ...state,
        init:false,
        ghtf:{
          ...state.ghtf,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_GHTF_SUCCESS:
      return {
        ...state,
        ghtf:{
          ...state.ghtf,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_GHTF_ERROR:
      return {
        ...state,
        ghtf:{
          ...state.ghtf,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_DIAGNOSTIC_CLASS:
      return {
        ...state,
        init:false,
        diagnostic_class:{
          ...state.diagnostic_class,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_DIAGNOSTIC_CLASS_SUCCESS:
      return {
        ...state,
        diagnostic_class:{
          ...state.diagnostic_class,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_DIAGNOSTIC_CLASS_ERROR:
      return {
        ...state,
        diagnostic_class:{
          ...state.diagnostic_class,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_ISO:
      return {
        ...state,
        init:false,
        iso:{
          ...state.iso,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_ISO_SUCCESS:
      return {
        ...state,
        iso:{
          ...state.iso,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_ISO_ERROR:
      return {
        ...state,
        iso:{
          ...state.iso,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_GT_CERTIFICATE:
      return {
        ...state,
        init:false,
        gt_certificate:{
          ...state.gt_certificate,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_GT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        gt_certificate:{
          ...state.gt_certificate,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_GT_CERTIFICATE_ERROR:
      return {
        ...state,
        gt_certificate:{
          ...state.gt_certificate,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_SERVICE_TYPE:
      return {
        ...state,
        init:false,
        service_type:{
          ...state.service_type,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        service_type:{
          ...state.service_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_SERVICE_TYPE_ERROR:
      return {
        ...state,
        service_type:{
          ...state.service_type,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_BIOEQUIVALENCE:
      return {
        ...state,
        init:false,
        bioequivalence:{
          ...state.bioequivalence,
          loading: true,
          data:[],
          message: ''
        }
      }
    case SEARCH_BIOEQUIVALENCE_SUCCESS:
      return {
        ...state,
        bioequivalence:{
          ...state.bioequivalence,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_BIOEQUIVALENCE_ERROR:
      return {
        ...state,
        bioequivalence:{
          ...state.bioequivalence,
          loading: false,
          data: [],
          message: 'No se encotraron datos'
        }
      }
    case SEARCH_VEHICLE_TYPE:
      return {
        ...state,
        init: false,
        vehicle_type: {
          ...state.vehicle_type,
          loading: true,
          data: [],
          message: ''
        }
      }
    case SEARCH_VEHICLE_TYPE_SUCCESS:
      return {
        ...state,
        vehicle_type: {
          ...state.vehicle_type,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_VEHICLE_TYPE_ERROR:
      return {
        ...state,
        vehicle_type: {
          ...state.vehicle_type,
          loading: false,
          data: [],
          message: 'No se encontraron datos'
        }
      }
    case SEARCH_FREQUENCY_MTO:
      return {
        ...state,
        init: false,
        frequency_mto: {
          ...state.frequency_mto,
          loading: true,
          data: [],
          message: ''
        }
      }
    case SEARCH_FREQUENCY_MTO_SUCCESS:
      return {
        ...state,
        frequency_mto: {
          ...state.frequency_mto,
          loading: false,
          data: action.payload,
          message: ''
        }
      }
    case SEARCH_FREQUENCY_MTO_ERROR:
      return {
        ...state,
        frequency_mto: {
          ...state.frequency_mto,
          loading: false,
          data: [],
          message: 'No se encontraron datos'
        }
      }
    case SEARCH_AMBULANCE_PLATE:
      return {
        ...state,
        init: false,
        ambulance_plate: { ...state.ambulance_plate, loading: true, data: [], message: '' }
      }
    case SEARCH_AMBULANCE_PLATE_SUCCESS:
      return {
        ...state,
        ambulance_plate: { ...state.ambulance_plate, loading: false, data: action.payload, message: '' }
      }
    case SEARCH_AMBULANCE_PLATE_ERROR:
      return {
        ...state,
        ambulance_plate: { ...state.ambulance_plate, loading: false, data: [], message: 'No se encontraron datos' }
      }
    case SEARCH_AMBULANCE_CHASIS:
      return {
        ...state,
        init: false,
        ambulance_chasis: { ...state.ambulance_chasis, loading: true, data: [], message: '' }
      }
    case SEARCH_AMBULANCE_CHASIS_SUCCESS:
      return {
        ...state,
        ambulance_chasis: { ...state.ambulance_chasis, loading: false, data: action.payload, message: '' }
      }
    case SEARCH_AMBULANCE_CHASIS_ERROR:
      return {
        ...state,
        ambulance_chasis: { ...state.ambulance_chasis, loading: false, data: [], message: 'No se encontraron datos' }
      }
    case SEARCH_AMBULANCE_CODE_IGSS:
      return {
        ...state,
        init: false,
        ambulance_code_igss: { ...state.ambulance_code_igss, loading: true, data: [], message: '' }
      }
    case SEARCH_AMBULANCE_CODE_IGSS_SUCCESS:
      return {
        ...state,
        ambulance_code_igss: { ...state.ambulance_code_igss, loading: false, data: action.payload, message: '' }
      }
    case SEARCH_AMBULANCE_CODE_IGSS_ERROR:
      return {
        ...state,
        ambulance_code_igss: { ...state.ambulance_code_igss, loading: false, data: [], message: 'No se encontraron datos' }
      }
    default:
      return { ...state };
  }
};